import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import { Panel, PanelHeader, PanelBody, PanelFooter } from "../../components/panel/panel.jsx";

import { useActividadesEconomicas } from "../../hooks_cache/useActividadesEconomicas.js";
import { useDepartamentos } from "../../hooks_cache/useDepartamento.js";
import { useMunicipios } from "../../hooks_cache/useMunicipio.js";

import { useNavigate } from "react-router-dom";

import api from "../../config/axiosConfig.js";

import { login } from "../../redux/authSlice";

const initialFormData = {
  nombre: "",
  nrc: "",
  nit: "",
  direccion_completa: "",
  id_actividadEconomica: null,
  correo: "",
  telefono: "",
};

const CompanyInfo = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { empresas, empresaSeleccionada } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState(initialFormData);

  const { data: actividades } = useActividadesEconomicas();
  const { data: municipios } = useMunicipios();
  const { data: departamentos } = useDepartamentos();

  const [errores, setErrores] = useState({});

  const [MiEmpresa, setMiEmpresa] = useState({});
  const esNuevaEmpresa = !MiEmpresa?.id;

  useEffect(() => {
    if (empresas.length > 0) {
      setMiEmpresa(empresaSeleccionada);
    }
  }, [empresaSeleccionada, empresas]);

  useEffect(() => {
    setFormData((prev) => ({ ...prev, ...MiEmpresa }));
  }, [MiEmpresa]);

  // Manejar cambios en los inputs
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Manejar cambios en select
  const handleSelectChange = (selectedOption, { name }) => {
    setFormData((prev) => ({
      ...prev,
      [name]: selectedOption ? selectedOption.value : null,
    }));
  };

  const handleSubmit = async (e) => {
    console.log("preparando para enviar:", formData);
    e.preventDefault();
    if (!validate()) {
      return;
    }

    console.log("preparando para enviar:", formData);

    let response;
    if (esNuevaEmpresa) {
      response = await api.post("/empresa", {
        ...formData,
      });
      await refreshData();
      navigate("/");
    } else {
      response = await api.put(`/${MiEmpresa.id}/empresa`, {
        ...formData,
      });
    }
  };

  const refreshData = async () => {
    const perfil = await api.get("/auth/session");
    dispatch(
      login({
        user: perfil.data.user,
        token: localStorage.getItem("token"),
        empresas: perfil.data.empresas,
      })
    );
  };

  const validate = () => {
    let nuevosErrores = {};

    if (!formData.nombre) nuevosErrores["nombre"] = "El campo nombre es obligatorio.";
    if (!formData.direccion_completa) nuevosErrores["direccion_completa"] = "El campo dirección es obligatorio.";
    if (!formData.telefono) nuevosErrores["telefono"] = "El campo teléfono es obligatorio.";
    if (!formData.id_departamento) nuevosErrores["id_departamento"] = "El campo departamento es obligatorio.";
    if (!formData.id_municipio) nuevosErrores["id_municipio"] = "El campo municipio es obligatorio.";
    if (!formData.correo && !esNuevaEmpresa) nuevosErrores["correo"] = "El campo correo es obligatorio.";

    if (formData.nrc.length > 0 && formData.id_actividadEconomica == null) {
      nuevosErrores["actividad_economica"] = "Si asigna un numero registro fiscal (NRC) debe especificar su actividad economica.";
    }

    if (Object.keys(nuevosErrores).length > 0) {
      setErrores(nuevosErrores);
      console.log("errores encontrados", nuevosErrores);
      return false;
    }

    console.log("validación exitosa");
    setErrores({});
    return true;
  };

  const renderInput = (label, name, col = 3, disabled = false, type = "text", forceEnable = false) => (
    <div className={`col-md-${col}`}>
      <div className="form-floating mb-3 mb-md-0">
        <input
          type={type}
          className="form-control fs-15px"
          placeholder={label}
          name={name}
          value={formData[name] || ""}
          onChange={handleChange}
          disabled={forceEnable ? false : disabled}
        />
        <label className="d-flex align-items-center fs-13px">{label}</label>
      </div>
      {errores[name] && <p style={{ color: "red" }}>* {errores[name]}</p>}
    </div>
  );

  const vincularCuenta = async (provider) => {
    try {
      const { id } = MiEmpresa;
      const response = await api.get(`/${id}/${provider}-auth`);
      const {
        data: { url },
      } = response;

      if (!url) {
        console.error(`No se recibió URL de autenticación para ${provider}`);
        return;
      }

      const width = 600;
      const height = 700;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      window.open(url, `popup${provider}`, `width=${width},height=${height},top=${top},left=${left}`);
    } catch (error) {
      console.error(`Error obteniendo URL de autenticación para ${provider}:`, error);
    }
  };

  useEffect(() => {
    const handleMessage = async (event) => {
      if (event.data?.status === "success") {
        console.log("✅ Gmail autenticado correctamente");
        // aquí puedes actualizar el estado, recargar datos, etc.
        await refreshData();
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <Panel>
      <PanelHeader noButton={true}>Mi Empresa</PanelHeader>

      <PanelBody>
        <form onSubmit={handleSubmit}>
          <div className="row mb-md-4">
            {renderInput("NOMBRE O RAZON SOCIAL", "nombre", 6, true, "text", esNuevaEmpresa)}
            {renderInput("NUMERO DE REGISTRO", "nrc", 3, true, "text", esNuevaEmpresa)}
            {renderInput("NIT", "nit", 3, true, "text", esNuevaEmpresa)}
          </div>

          <div className="row mb-md-4">
            {renderInput("NOMBRE COMERCIAL", "nombreComercial", 6, false)}

            {renderInput("DIRECCION", "direccion_completa", 6)}
          </div>

          <div className="row mb-md-4">
            <div className="col-md-6">
              <div className="mb-3 mb-md-0">
                <label className="form-label">ACTIVIDAD ECONOMICA:</label>
                <Select
                  name="id_actividadEconomica"
                  options={actividades?.map((actividad) => ({
                    value: actividad.id,
                    label: `${actividad.codigo} - ${actividad.descripcion}`,
                  }))}
                  value={
                    formData.id_actividadEconomica
                      ? {
                          value: formData.id_actividadEconomica,
                          label: actividades?.find((a) => a.id === formData.id_actividadEconomica)?.["descripcion"] || "Error..",
                        }
                      : null
                  }
                  isSearchable
                  isClearable
                  placeholder="Seleccione una actividad economica"
                  onChange={handleSelectChange}
                  autocomplete="off"
                  defaultValue=""
                />
                {errores["actividad_economica"] && <p style={{ color: "red" }}>* {errores["actividad_economica"]}</p>}
              </div>
            </div>

            <div className="col-md-3">
              <div className="mb-3 mb-md-0">
                <label className="form-label">MUNICIPIO:</label>
                <Select
                  name="id_municipio"
                  options={municipios?.map((municipio) => ({
                    value: municipio.id,
                    label: `${municipio.codigo} - ${municipio.descripcion}`,
                  }))}
                  value={
                    formData.id_municipio
                      ? {
                          value: formData.id_municipio,
                          label: municipios?.find((a) => a.id === formData.id_municipio)?.["descripcion"] || "Error..",
                        }
                      : null
                  }
                  isSearchable
                  placeholder="Seleccione un municipio"
                  onChange={handleSelectChange}
                />
                {errores["id_municipio"] && <p style={{ color: "red" }}>* {errores["id_municipio"]}</p>}
              </div>
            </div>
            <div className="col-md-3">
              <div className="mb-3 mb-md-0">
                <label className="form-label">DEPARTAMENTO:</label>
                <Select
                  name="id_departamento"
                  options={departamentos?.map((depto) => ({
                    value: depto.id,
                    label: `${depto.codigo} - ${depto.descripcion}`,
                  }))}
                  value={
                    formData.id_departamento
                      ? {
                          value: formData.id_departamento,
                          label: departamentos?.find((a) => a.id === formData.id_departamento)?.["descripcion"] || "Error..",
                        }
                      : null
                  }
                  isSearchable
                  placeholder="Seleccione un departamento"
                  onChange={handleSelectChange}
                />
                {errores["id_departamento"] && <p style={{ color: "red" }}>* {errores["id_departamento"]}</p>}
              </div>
            </div>
          </div>

          <div className="row">
            {!esNuevaEmpresa && (
              <div className="col-md-3">
                <div className="form-floating mb-md-0">
                  <input
                    type="email"
                    className="form-control fs-15px"
                    placeholder="EMAIL"
                    name="correo"
                    value={formData["correo"] || ""}
                    onChange={handleChange}
                    disabled={true}
                  />
                  <label className="d-flex align-items-center fs-13px">EMAIL</label>
                </div>
                {errores["correo"] && <p style={{ color: "red" }}>* {errores["correo"]}</p>}

                <button
                  style={{ width: "100%", marginTop: "5px" }}
                  href="javascript:;"
                  className="btn btn-social btn-google"
                  onClick={() => vincularCuenta("gmail")}
                >
                  <span className="fab fa-google"></span> Vincular cuenta GOOGLE
                </button>

                {/* <button
                  style={{ width: "100%", marginTop: "5px" }}
                  href="javascript:;"
                  className="btn btn-social btn-microsoft"
                  onClick={() => vincularCuenta("outlook")}
                >
                  <span className="fab fa-microsoft"></span> Vincular cuenta MICROSOFT
                </button> */}
              </div>
            )}
            {renderInput("TELEFONO", "telefono")}
          </div>
        </form>
      </PanelBody>
      <PanelFooter className="text-center border-1">
        <button onClick={handleSubmit} className="btn btn-green btn-lg ms-5px mb-2">
          Guardar Cambios
        </button>
      </PanelFooter>
    </Panel>
  );
};

export default CompanyInfo;
